import {
  BuildingsIcon,
  CallIncomingIcon,
  CallOutgoingIcon,
  ChainLink4Icon,
  HomeDoorIcon,
  VideoIcon,
} from '@fingertip/icons'
import React, { useMemo } from 'react'

import { TooltipWrapper } from '@/components/shared/tooltip-wrapper'
import { Badge } from '@/components/ui/badge'
import { BookingLocation } from '@/lib/stores/booker-store'

type Props = {
  location: BookingLocation
}

const ICON_SIZE = 16

export const BookingLocationBadge = ({ location }: Props) => {
  const locationHelpText = useMemo(() => {
    switch (location.type) {
      case 'LINK':
        return 'Link'
      case 'ATTENDEE_IN_PERSON':
        return 'Attendee In Person'
      case 'HOST_IN_PERSON':
        return 'Host In Person'
      case 'ATTENDEE_PHONE':
        return 'Attendee Phone'
      case 'HOST_PHONE':
        return 'Host Phone'
      case 'CONFERENCING':
        return 'Conferencing'
    }
  }, [location.type])

  return (
    <TooltipWrapper message={locationHelpText}>
      <Badge className="m-0 h-9 p-2 text-sm">
        {location.type === 'LINK' && (
          <ChainLink4Icon
            width={ICON_SIZE}
            height={ICON_SIZE}
            className="shrink-0"
          />
        )}

        {location.type === 'ATTENDEE_IN_PERSON' && (
          <BuildingsIcon
            width={ICON_SIZE}
            height={ICON_SIZE}
            className="shrink-0"
          />
        )}

        {location.type === 'HOST_IN_PERSON' && (
          <HomeDoorIcon
            width={ICON_SIZE}
            height={ICON_SIZE}
            className="shrink-0"
          />
        )}

        {location.type === 'ATTENDEE_PHONE' && (
          <CallIncomingIcon
            width={ICON_SIZE}
            height={ICON_SIZE}
            className="shrink-0"
          />
        )}

        {location.type === 'HOST_PHONE' && (
          <CallOutgoingIcon
            width={ICON_SIZE}
            height={ICON_SIZE}
            className="shrink-0"
          />
        )}

        {location.type === 'CONFERENCING' && (
          <VideoIcon
            width={ICON_SIZE}
            height={ICON_SIZE}
            className="shrink-0"
          />
        )}
      </Badge>
    </TooltipWrapper>
  )
}
